export default function CompanyProfileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.66797 18.334L18.3346 18.334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.0013 7.5L11.668 7.5C9.59964 7.5 9.16797 7.93167 9.16797 10L9.16797 18.3333H17.5013V10C17.5013 7.93167 17.0696 7.5 15.0013 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 18.3346L2.5 18.3346L2.5 4.16797C2.5 2.09964 2.93167 1.66797 5 1.66797L10 1.66797C12.0683 1.66797 12.5 2.09964 12.5 4.16797L12.5 7.5013"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5L5 5M2.5 8.33333H5M2.5 11.6667H5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12.5 10.834H14.1667M12.5 13.334H14.1667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.3359 18.334L13.3359 15.834"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
